import { Component, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-retry-contact-modal',
  templateUrl: './retry-contact-modal.component.html',
  styleUrls: ['./retry-contact-modal.component.scss']
})
export class RetryContactModalComponent implements OnChanges {
  @Input() isLoading: boolean = true;
  @Input() isSuccess: boolean = false;

  constructor(public activeModal: NgbActiveModal, private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isLoading']) {
      console.log('isloading')
    }
    if (changes['isSuccess']) {
      console.log('isSuccess')
    }

    this.cdr.detectChanges();
  }

  closeAfterSuccess(): void {
    setTimeout(() => {
      this.activeModal.close();
    }, 2000);
  }
}
